import ViewCustomer from '../../pages/Customer/ViewCustomer';
import { customerStore } from '../../stores';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
const ViewCustomerContainer = ({ closeModal, goToEditCustomer, goBack }) => {
	const [customerViewMenu, setCustomerViewMenu] = useState(false);

	const showCustomerViewMenu = () => {
		setCustomerViewMenu(!customerViewMenu);
	};

	return (
		<ViewCustomer
			closeModal={closeModal}
			customerViewMenu={customerViewMenu}
			customer={customerStore.selectedCustomer}
			showCustomerViewMenu={showCustomerViewMenu}
			goToEditCustomer={goToEditCustomer}
			goBack={goBack}
		/>
	);
};

export default observer(ViewCustomerContainer);
